module.exports = __webpack_public_path__ + "static/media/posters-banner-SEAADE.e2223dd2.jpg";